// import Swiper JS
import Swiper from "swiper";
// core version + navigation, pagination modules:
import SwiperCore, {
    Navigation,
    Pagination,
    Mousewheel,
    Parallax,
    Thumbs,
    Lazy,
} from "swiper/core";
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Mousewheel, Parallax, Thumbs, Lazy]);

// import Swiper styles
import "swiper/swiper-bundle.css";
import { URLASSOLUTO } from "./variables";

const swiper = $(document).ready(function () {

    let swiperquestionarioOpts = {
        lazy: true,
        preloadImages: true,
        autoHeight: true, //enable auto height
        debugger: true,
        loop: false,
        observer: true,
        allowTouchMove: false,
        observeParents: true,
        slidesPerView: 1,
        autoResize: false,
        navigation: {
            nextEl: ".swiper-button-next.swiperquestionario",
            prevEl: ".swiper-button-prev.swiperquestionario",
        },
        on: {
            slideChange: function () {
            const lastIndex = this.slides.length - 1;
            const isLast = this.activeIndex === lastIndex;

            if (isLast) {
                $('.submitquestionario').removeClass('d-none');
            } else {
                $('.submitquestionario').addClass('d-none');
            }
            },
        },
    };
    var swiperquestionario = new Swiper(
        ".swiper-container.swiperquestionario",
        swiperquestionarioOpts
    );

    let swiper0Opts = {
        lazy: true,
        preloadImages: true,
        autoHeight: false, //enable auto height
        debugger: true,
        loop: false,
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        autoResize: false,
        navigation: false,
        pagination: {
            el: '.swiper-pagination', // selettore dei dots
            clickable: true,          // rende i dots cliccabili
        },
    };
    var swiper0 = new Swiper(
        ".swiper-container.swiper0",
        swiper0Opts
    );

    let swiperfaketabsOpts = {
        lazy: true,
        preloadImages: true,
        autoHeight: false, //enable auto height
        debugger: true,
        loop: false,
        observer: true,
        observeParents: true,
        slidesPerView: 1.5,
        spaceBetween: 25,
        autoResize: false,
        navigation: false,
        breakpoints: {
            576: {
                spaceBetween: 25,
                slidesPerView: 2.3,
            },
            768: {
                slidesPerView: 2.3,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 3.3,
                spaceBetween: 20,
            },
            1400: {
                slidesPerView: 4,
                spaceBetween: 25,
            },
        },
        on: {
            init: function () {
                let swiper = this;
                setTimeout(() => {
                    $(".sameheightafter").boxheight();
                }, 100); // Attendi un po' prima di eseguire la funzione
            }
        }
    };
    var swiperfaketabs = new Swiper(
        ".swiper-container.swiperfaketabs",
        swiperfaketabsOpts
    );

    let swipernewsOpts = {
        lazy: true,
        preloadImages: true,
        autoHeight: false, //enable auto height
        debugger: true,
        loop: false,
        observer: true,
        observeParents: true,
        slidesPerView: 1.5,
        spaceBetween: 25,
        autoResize: false,
        navigation: false,
        breakpoints: {
            576: {
                spaceBetween: 25,
                slidesPerView: 2.3,
            },
            768: {
                slidesPerView: 2.3,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 3.3,
                spaceBetween: 20,
            },
            1400: {
                slidesPerView: 4,
                spaceBetween: 25,
            },
        },
        on: {
            init: function () {
                let swiper = this;
                setTimeout(() => {
                    $(".sameheightafter").boxheight();
                }, 100); // Attendi un po' prima di eseguire la funzione
            }
        }
    };
    var swipernews = new Swiper(
        ".swiper-container.swipernews",
        swipernewsOpts
    );

    let swipervideoOpts = {
        lazy: true,
        preloadImages: true,
        autoHeight: false, //enable auto height
        debugger: true,
        loop: false,
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        autoResize: false,
        navigation: false,
        pagination: {
            el: '.swiper-pagination', // selettore dei dots
            clickable: true,          // rende i dots cliccabili
        },
    };
    var swipervideo = new Swiper(
        ".swiper-container.swipervideo",
        swipervideoOpts
    );


    let swiperreviewOpts = {
        lazy: true,
        preloadImages: true,
        autoHeight: false, //enable auto height
        debugger: true,
        loop: false,
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        autoResize: false,
        navigation: false,
        pagination: {
            el: '.swiper-pagination', // selettore dei dots
            clickable: true,          // rende i dots cliccabili
        },
    };
    var swiperreview = new Swiper(
        ".swiper-container.swiperreview",
        swiperreviewOpts
    );

});

export { swiper as default };
